import React, { useEffect } from "react"
import { Outlet, useParams } from "react-router-dom"
import GuideHeader from "components/guides/Header"
import withDefaultErrorBoundary from "modules/errors/HOCs/withDefaultErrorBoundary"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import FirstLoading from "modules/loader-watchers/FirstLoading"

import { useDispatch, useSelector } from "react-redux"
import { cleanGuide, getClientGuide } from "store/guides"
import { modelSelector } from "store/selectors"
import NavigationReskin from "components/guides/NavigationReskin"

function GuideLayoutReskin() {
  const params = useParams()
  const dispatch = useDispatch()
  const guide = useSelector(modelSelector("guide"))

  useEffect(() => {
    dispatch(getClientGuide(params.slug))
    return () => dispatch(cleanGuide())
  }, [params.slug, dispatch])

  return (
    <main className="p-20">
      <div>
        <FirstLoading name="guides.guide" className="d-none">
          <GuideHeader guide={guide} />
        </FirstLoading>
        <NavigationReskin slug={guide.slug} />
      </div>
      <div className="flex-fill py-20">
        <FirstLoading name="guides.guide">
          <DefaultErrorBoundary>
            <Outlet />
          </DefaultErrorBoundary>
        </FirstLoading>
      </div>
    </main>
  )
}

export default withDefaultErrorBoundary(GuideLayoutReskin)
